import { env } from "@/config";
import * as Sentry from "@sentry/browser";

if (env === "production") {
  Sentry.init({
    dsn: "https://27ae241725f44c7597f51960b3c2d897@o46964.ingest.sentry.io/279289",

    // Don't sample anything from users that don't error out
    // replaysSessionSampleRate: 0,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    // replaysOnErrorSampleRate: 0.1,
    integrations: [],
    debug: false, // TIP: This is very handy for local development!
    ignoreErrors: [
      // Common errors happening in different places that we can't do anything with
      /^Failed to fetch$/,
      /^Load failed$/,
      /^NetworkError when attempting to fetch resource\.$/,
    ],
  });
}
